
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { adminUpdateDocumentTrailer, removeAdminTrailerDocItem } from "../../features/admin2/admin2Slice"
import SmallSpinner from "../shared/spinners/SmallSpinner"
import Btn from "../shared/button/Btn"
import { showModal } from "../../features/modal/modalSlice"
import { toast } from "react-toastify"
import ImageUploader from "../docs/ImageUploader"
import { validateFile } from "../../helper/docs/validateFile"

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    color: ${({theme}) => theme.mainTextColor};

    .doc-container{
        width: 100%;
        height: calc(100% - 80px);

        h4{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-lg);
        }
    }

    .doc-list{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 30px;
        width: 100%;
        padding: 20px 0;
        height: 500px;
        max-height: 500px;
        overflow: auto;
        border-top: 1px solid ${({theme})=> theme.mainTextColor};

        &::-webkit-scrollbar {
            width: 0;
            width: 8px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({theme})=> theme.scrollThumbColor};
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }
           
        .doc-item{
            width: calc(50% - 15px);
            height: 400px;
            border: 1px solid ${({theme}) => theme.mainTextColor};
            border-radius: 10px;
            overflow: hidden;
            
            .doc-item-top{
                width: 100%;
                height: 50px;
                border: 1px solid ${({theme}) => theme.mainBorderColor};
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);

                .action{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;

                        span{

                            &:first-child{
                                width: 60px;
                            }
                        }


                        .delete-btn{
                            font-size: var(--font-size-sm);
                            font-weight: var(--font-weight-lg);
                            /* background-color: var(--color-main); */
                            color: #fff;
                            color: var(--color-main);
                            border: 1px solid var(--color-main);
                            padding: 5px 7px;
                            border-radius: 5px;
                            cursor: pointer;
                            margin-right: 10px;
                            transition: .2s;

                            &:hover{
                                background-color: var(--color-main);
                                color: #fff;
                            }
                        }
                    }

            }
        }

        .new-select-item{
            border-color: red;
            border-width: 2px;

            .new-select-item-top{
                background-color: #ff000040;
            }
        }

    }

    .btn-container{
        display: flex;
        justify-content: center;
        gap: 50px;
        width: 100%;
        padding: 20px 0;
        border-top: 1px solid ${({theme}) => theme.mainBorderColor};
    }
`

const AdminAracTrailerDocs = () => {
    const {selectAdminArac, isLoadingAdminUpdateDocumentTrailer } = useSelector(state => state.admin2)
    const dispatch = useDispatch()

    const [fileList, setFileList] = useState([
        {
            selectedFile: null,
            loadedBefore:  selectAdminArac.ruhsatPhoto ? selectAdminArac.ruhsatPhoto : null,
            fileTypeName: "Ruhsat",
            staticValue: "ruhsat"
        },
        {
            selectedFile: null,
            loadedBefore: selectAdminArac.tasitKartiPhoto ? selectAdminArac.tasitKartiPhoto : null,
            fileTypeName: "Taşıt Kartı",
            staticValue: "TasitKartiPhoto"
        },
        {
            selectedFile: null,
            loadedBefore: selectAdminArac.sasePhoto ? selectAdminArac.sasePhoto : null,
            fileTypeName: "Şase",
            staticValue: "SasePhoto"
        },
    ])

    const handleFileSelect = async(index, files) => {
        const file = await validateFile({file: files[0], maxSize: 5 * 1024 * 1024, allowedTypes:['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']})
        
        if(file){
            const newUploads = [...fileList];
            newUploads[index].selectedFile = files[0];
            setFileList(newUploads);
        }
      };


        const handleSubmit = async () => {
        const updatedItems = fileList.filter(item => item.selectedFile);
        const results = [];
        for (const [index, item] of updatedItems.entries()) {
          try {
            const result = await dispatch(adminUpdateDocumentTrailer({
                plateNumber: selectAdminArac.trailerPlateNumber,
                documentType: item.staticValue,
                imageFile: item.selectedFile
            }));
results.push({ status: "fulfilled", value: result });
            if(result.meta.requestStatus === "fulfilled"){
                toast.success(`${item.fileTypeName} belgesi başarıyla sisteme yüklendi.`, {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });

    
            }
            else{
                toast.error(`${item.fileTypeName} sisteme yüklenemedi.`, {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }

          } catch (error) {
            results.push({ status: "rejected", reason: error });
            
          }
        }

        const latestData = results[results.length-1]?.value?.payload
        
        setFileList([
            {
                selectedFile: null,
                loadedBefore:  latestData.ruhsatPhoto ? latestData.ruhsatPhoto : null,
                fileTypeName: "Ruhsat",
                staticValue: "ruhsat"
            },
            {
                selectedFile: null,
                loadedBefore: latestData.tasitKartiPhoto ? latestData.tasitKartiPhoto : null,
                fileTypeName: "Taşıt Kartı",
                staticValue: "TasitKartiPhoto"
            },
            {
                selectedFile: null,
                loadedBefore: latestData.sasePhoto ? latestData.sasePhoto : null,
                fileTypeName: "Şase",
                staticValue: "SasePhoto"
            },
        ])

      };

      const handleRemoveDoc = async(fileItem) => {
       const result = await dispatch(removeAdminTrailerDocItem({trailerId: selectAdminArac.id, documentType: fileItem.staticValue}));

       if(result.meta.requestStatus === "fulfilled"){
            setFileList(fileList.map(item => {
                if(item.staticValue === fileItem.staticValue){
                    return {...item, loadedBefore: null}
                }
                else{
                    return item
                }
            }))
        }
      }
      

  return (
    <Container>
        <div className="doc-container">
            <h4>Plaka: {selectAdminArac?.truckPlateNumber}</h4>
            <div className="doc-list">
                {
                    fileList.map((fileItem, index) => {
                        let previewSrc;
                        let isPdf;
                        if (fileItem.selectedFile) {
                            isPdf = fileItem.selectedFile.type === "application/pdf"
                          previewSrc = URL.createObjectURL(fileItem.selectedFile);

                        } else if (fileItem.loadedBefore) {
                          previewSrc = `${process.env.REACT_APP_API_IMG_URI}${fileItem.loadedBefore}`;
                        } else {
                          previewSrc = "question";
                        }

                        return (
                            <div className={fileItem.selectedFile ? "new-select-item doc-item" : "doc-item"}>
                                 <div className={fileItem.selectedFile ? "new-select-item-top doc-item-top" : "doc-item-top"}>
                                    {fileItem.selectedFile ? (
                                        <p>Yeni Seçilen Belge: {fileItem.selectedFile.name} - ({fileItem.fileTypeName})</p>
                                    ) : fileItem.loadedBefore ? (
                                        <p className="action">
                                            <span></span>
                                            <span>Önceden Yüklenmiş Belge - ({fileItem.fileTypeName})</span>
                                            <button className="delete-btn" onClick={() => handleRemoveDoc(fileItem)}>Belgeyi Sil</button>
                                        </p>
                                    ) : (
                                        <p>Belge Seçilmedi - ({fileItem.fileTypeName})</p>
                                    )}
                                </div>
                                <ImageUploader
                                    previewSrc={previewSrc}
                                    isPdf={isPdf} 
                                    onFileSelect={(files) => handleFileSelect(index, files)} 
                                />
                            </div>
                        )
                    }) 
                }
            </div>
        </div>
        <div className="btn-container">
            <Btn handleClick={handleSubmit} width={"220px"} bgColor="#E85446" color="#fff" padding="10px" isDisabled={fileList.filter(item => item.selectedFile).length < 1}>{isLoadingAdminUpdateDocumentTrailer ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : fileList.filter(item => item.selectedFile).length < 1 ? "Değişiklik Yok":  `${fileList.filter(item => item.selectedFile).length} Değişiklik Kaydet`}</Btn>
            <Btn handleClick={() => dispatch(showModal(null))} width={"220px"} bgColor="transparent" borderColor="#E85446" color="#E85446" padding="10px">Vazgeç</Btn>
        </div>
    </Container>
  )
}

export default AdminAracTrailerDocs